<template>
  <exam-program-presentation-list />
</template>

<script>
import ExamProgramPresentationList from './List.vue'

export default {
  components: { ExamProgramPresentationList },
}
</script>
